export default __webpack_public_path__ + "599756fb7419385d3b816efd0a071e5c.png";